import { render, staticRenderFns } from "./AccountSettingsChangePassword.vue?vue&type=template&id=bd04c6e2&scoped=true&"
import script from "./AccountSettingsChangePassword.vue?vue&type=script&lang=ts&"
export * from "./AccountSettingsChangePassword.vue?vue&type=script&lang=ts&"
import style0 from "./AccountSettingsChangePassword.vue?vue&type=style&index=0&id=bd04c6e2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd04c6e2",
  null
  
)

export default component.exports